"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _FormLabel = require("../FormLabel/FormLabel");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormDropdown = require("./FormDropdown.styled");
var _reactstrap = require("reactstrap");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _FormMessage = require("../FormMessage/FormMessage");
var _excluded = ["labelText", "required", "message", "hasError", "options", "selected", "onChange", "id", "aria-label"],
  _excluded2 = ["data-testid"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FormDropdown = exports.FormDropdown = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _props$disabled;
  var labelText = _ref.labelText,
    required = _ref.required,
    message = _ref.message,
    hasError = _ref.hasError,
    options = _ref.options,
    selected = _ref.selected,
    onChange = _ref.onChange,
    id = _ref.id,
    ariaLabel = _ref['aria-label'],
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var selectedOption = options.find(function (option) {
    return option.value === selected;
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedLabel = _useState4[0],
    setSelectedLabel = _useState4[1];
  (0, _react.useEffect)(function () {
    var _selectedOption$label;
    var defaultOption = options[0];
    setSelectedLabel((_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.label);
  }, [options, selectedOption]);
  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };
  var handleSelected = function handleSelected(label, value) {
    setSelectedLabel(label);
    onChange && onChange(value, label);
  };
  var isDisabled = (_props$disabled = props['disabled']) !== null && _props$disabled !== void 0 ? _props$disabled : false;
  var _props$dataTestid = props['data-testid'],
    testId = _props$dataTestid === void 0 ? '' : _props$dataTestid,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_FormDropdown.StyledFormGroup, (0, _extends2["default"])({
    disabled: isDisabled
  }, rest), /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, (0, _extends2["default"])({
    id: "dropdown-label",
    label: labelText,
    labelFor: id,
    required: required,
    hidden: !labelText
  }, testId !== '' && {
    'data-testid': "".concat(testId, "_label")
  }, {
    useAs: "span"
  })), /*#__PURE__*/_react["default"].createElement(_FormDropdown.StyledDropdown, (0, _extends2["default"])({
    hasError: hasError,
    id: id,
    isOpen: dropdownOpen,
    toggle: toggle,
    "aria-expanded": dropdownOpen,
    "aria-haspopup": "true",
    "aria-invalid": hasError,
    "aria-label": ariaLabel,
    disabled: isDisabled,
    "data-testid": testId
  }, hasError && {
    'aria-describedby': 'selectMessage'
  }, {
    "aria-labelledby": "dropdown-label"
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    color: "primary",
    block: true,
    outline: true,
    "data-testid": "".concat(testId, "_selected_label")
  }, selectedLabel, /*#__PURE__*/_react["default"].createElement(_FormDropdown.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronDown
  })), /*#__PURE__*/_react["default"].createElement(_FormDropdown.StyledDropdownMenu, {
    role: "menu"
  }, options.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_FormDropdown.StyledDropdownMenuItem, (0, _extends2["default"])({
      role: "menuitemradio",
      onClick: function onClick() {
        return handleSelected(label, value);
      },
      key: value,
      value: value,
      selected: value === selected,
      "aria-checked": value === selected
    }, testId !== '' && {
      'data-testid': "".concat(testId, "_option_").concat(value)
    }), label);
  }))), message && /*#__PURE__*/_react["default"].createElement(_FormMessage.FormMessage, (0, _extends2["default"])({
    type: hasError ? 'error' : 'info',
    id: "selectMessage",
    text: message
  }, testId !== '' && {
    'data-testid': "".concat(testId, "_message")
  })));
});
FormDropdown.propTypes = {
  options: _propTypes["default"].array.isRequired,
  selected: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  labelText: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  testId: _propTypes["default"].string,
  'aria-label': _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired
};